import { render, staticRenderFns } from "./ObsMedia.vue?vue&type=template&id=b0abc54c&"
import script from "./ObsMedia.vue?vue&type=script&lang=js&"
export * from "./ObsMedia.vue?vue&type=script&lang=js&"
import style0 from "./ObsMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports